import { useLang } from "@/context/LangContext";
import { LegalLayout, LEGAL_ENTITY, LEGAL_JURISDICTION, SUPPORT_EMAIL } from "./LegalLayout";

export default function Legal() {
  const { lang } = useLang();
  const es = lang === "es";
  return (
    <LegalLayout title={es ? "Aviso Legal y Cookies" : "Legal Notice & Cookies"} updated={es ? "Última actualización: 2026" : "Last updated: 2026"}>
      <h2>{es ? "Titular" : "Owner"}</h2>
      <p>{es
        ? `Este sitio y el servicio URBIS son operados por ${LEGAL_ENTITY}, ${LEGAL_JURISDICTION.es}. Contacto: `
        : `This site and the URBIS service are operated by ${LEGAL_ENTITY}, ${LEGAL_JURISDICTION.en}. Contact: `}
        <a href={`mailto:${SUPPORT_EMAIL}`} className="text-primary">{SUPPORT_EMAIL}</a></p>

      <h2>{es ? "Propiedad intelectual" : "Intellectual property"}</h2>
      <p>{es ? "La marca URBIS, el software y los contenidos propios están protegidos. Los logos y contenidos de cada negocio pertenecen a sus respectivos titulares." : "The URBIS brand, software and proprietary content are protected. Each business's logos and content belong to their respective owners."}</p>

      <h2>{es ? "Cookies" : "Cookies"}</h2>
      <p>{es ? "Usamos cookies estrictamente necesarias para el funcionamiento (sesión de inicio de sesión, preferencias de idioma) y cookies técnicas de seguridad. No usamos cookies publicitarias de terceros." : "We use strictly necessary cookies for operation (login session, language preferences) and technical security cookies. We do not use third-party advertising cookies."}</p>
      <ul>
        <li>{es ? "Sesión: mantiene tu inicio de sesión activo." : "Session: keeps you logged in."}</li>
        <li>{es ? "Idioma: recuerda tu preferencia ES/EN." : "Language: remembers your ES/EN preference."}</li>
      </ul>
      <p>{es ? "Puedes bloquear las cookies desde tu navegador, aunque algunas funciones podrían dejar de operar." : "You can block cookies from your browser, though some features may stop working."}</p>

      <h2>{es ? "Responsabilidad" : "Liability"}</h2>
      <p>{es ? "URBIS actúa como plataforma de intermediación. La contratación de servicios ocurre directamente entre clientes y negocios; URBIS no es parte de dichos contratos." : "URBIS acts as an intermediation platform. Service engagements occur directly between clients and businesses; URBIS is not a party to those contracts."}</p>

      <h2>{es ? "Ley aplicable" : "Governing law"}</h2>
      <p>{es ? `Se aplican las leyes del ${LEGAL_JURISDICTION.es}.` : `The laws of the ${LEGAL_JURISDICTION.en} apply.`}</p>

      <p className="mt-8 rounded-sm bg-amber-50 p-3 text-xs text-amber-700">{es ? "Aviso: plantilla estándar. Revísala con un abogado antes de producción." : "Notice: standard template. Have it reviewed by an attorney before production."}</p>
    </LegalLayout>
  );
}
